<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="الإهـداء">
<h1><span dir="rtl">الإهـداء</span></h1>
<p><span dir="rtl">أمي.. أبي وشقيقاتي واشقائي:</span></p>
<p><span dir="rtl">أتمنى أن أكون شخصاً تتباهون باسمه..</span></p>
<p><span dir="rtl">شخصاً يضع تاجاً من الفخر على رؤوسِكم.</span></p>
<p><span dir="rtl">هأنا أظهر معدني الحقيقي</span></p><br/>
<p style="text-align:center; direction:ltr">Mum, Dad, my lovely sisters and brothers.</p>
<p style="text-align:center; direction:ltr">I hope that I’ll be someone you’re</p>
<p style="text-align:center; direction:ltr">proud to say its name<span dir="rtl">.</span></p>
<p style="text-align:center; direction:ltr">Someone will give you a crown made of glory<span dir="rtl">.</span></p>
<p style="text-align:center; direction:ltr">Here I’m showing you what I’ve made of<span dir="rtl">.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?f512300a